'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CompactDisc = require('./CompactDisc');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CompactDisc).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/CompactDisc/index.js
// module id = 1163
// module chunks = 1